import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { App } from './App'
import { initAnalytics } from './lib/analytics'

// Single CSS entry point — app.css imports preset.css (Tailwind v4 +
// Flowbite + Inter), then layers platform overrides on top.
import './app.css'

// Initialize analytics hooks (client-side).
// Product analytics events are tracked server-side via platform_sdk.analytics.
initAnalytics()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
    },
  },
})

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
